import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTheme } from '../../contexts/ThemeContext';
import useResponsive from '../../hooks/useResponsive';
import Drawer from './Drawer';
import Header from './Header';

function DashboardLayout({ menuItems }) {
  const { theme } = useTheme();
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);
  const { isDesktop } = useResponsive();

  return (
    <div style={{ ...styles.root, backgroundColor: theme.bg }}>
      <Header />
      <div style={{ ...styles.body, paddingTop: 60 }}>
        <Drawer menuItems={menuItems} />
        <main
          style={{
            ...styles.content,
            marginLeft: isDesktop && drawerOpen ? 260 : 0,
            transition: 'margin-left 0.3s ease',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '24px',
  },
};

export default DashboardLayout;
